import { UploadFile } from 'components/Upload';
import { ProtoObject } from 'types/common';
import { IFileType } from 'types/types/common';
import { generateUid } from 'utils';
import { getUrlWithToken } from 'api/helpers';

export const convertFile = (file: any): UploadFile => ({
  uid: file.id ? String(file.id) : generateUid(),
  name: file.name || file.originalFilename,
  size: file.size,
  type: file.documentType,
  status: 'done',
  url: file.document,
});

export const convertFileList = (fileList?: IFileType[] | ProtoObject): UploadFile[] => {
  return fileList && Array.isArray(fileList) ? fileList.map(convertFile) : [];
};

export const downloadFileByLink = async (
  fileName: string | undefined,
  fileLink: string,
  withToken = true,
) => {
  try {
    const url = withToken ? getUrlWithToken(fileLink) : fileLink;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    if (fileName) link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Ошибка при скачивании файла:', error);
    // Fallback к обычной ссылке
    const link = document.createElement('a');
    const url = withToken ? getUrlWithToken(fileLink) : fileLink;
    link.href = url;
    if (fileName) link.download = fileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
